const DEFAULT_LANG = 'pt-BR';
const DEFAULT_CURRENCY = 'BRL';

/** Raw cent digits — allows up to R$ 9.999.999,99 */
export const CURRENCY_INPUT_MAX_DIGITS = 9;

export function formatCurrency(
  raw: string | number,
  lang: string = DEFAULT_LANG,
  currency: string = DEFAULT_CURRENCY
): string {
  const value =
    typeof raw === 'number'
      ? raw
      : parseInt((raw || '').replace(/\D/g, ''), 10) / 100 || 0;

  return value.toLocaleString(lang, { style: 'currency', currency });
}

export function getFormattedCurrency(
  value: number,
  lang: string = DEFAULT_LANG,
  currency: string = DEFAULT_CURRENCY
): string {
  return formatCurrency(value, lang, currency);
}

export function formatCurrencyFromString(
  raw: string,
  lang: string = DEFAULT_LANG,
  currency: string = DEFAULT_CURRENCY
): string {
  return formatCurrency(raw, lang, currency);
}

export function formatCurrencyInputValue(
  raw: string,
  maxDigits: number = CURRENCY_INPUT_MAX_DIGITS
): string {
  const digits = raw.replace(/\D/g, '').slice(0, maxDigits);
  return digits ? formatCurrencyFromString(digits) : '';
}
